<template>
  <div class="w-screen min-h-screen flex flex-col items-center">
    <div
      class="grid p-8 text-center justify-center items-center content-center my-auto"
    >
      <Icon name="BadgeCheck" class="w-12 h-12 text-green-600 mx-auto mb-4" />
      <h2 class="text-4xl font-semibold mb-4 leading">
        🙌 Congratulation for your new Membership! 🎉
      </h2>
      <p class="mb-10 text-lg">You can start learning from the best ad inspiration now</p>
      <p class="text-lg">Redirecting...</p>
    </div>
    <!-- <div class="max-w-screen-xl text-left mt-auto">
      <p>If you’re having trouble with the platform, please contact us.</p>
      <p>
        Any issues with it? Please send us an email to
        <a
          href="mailto:hello@meetadbox.com"
          target="_blank"
          class="font-semibold"
          >hello@meetadbox.com</a
        >
        and we will send it to you right away!
      </p>
    </div> -->
    <div class="py-3">
      <p>Please <a href="https://app.meetadbox.com" class="text-blue-600 font-medium">click here</a> if you are not redirected within a few seconds</p>
    </div>
    <footer class="w-full bg-gray-900 text-white flex py-6 px-20">
      <p class="mr-auto">
        © 2022 Adbox, all rights reserved.
        <a href="mailto:hello@meetadbox.com" target="_blank"
          >hello@meetadbox.com</a
        >
      </p>
      <a
        href="https://meetadbox.com/terms"
        target="_blank"
        class="font-semibold text-green-500 mr-4"
        >Terms of Service</a
      >
      <a
        href="https://meetadbox.com/privacy"
        target="_blank"
        class="font-semibold text-green-500"
        >Privacy Policy</a
      >
    </footer>
  </div>
</template>

<script>
import Icon from "@/components/UI/Icon";

export default {
  components: { Icon },
};
</script>

<style></style>
